import React from 'react';

import classNames from 'classnames';

import styles from './CheckBox.module.css';
import { useOrionUID } from '../../helpers/orionUID';
import { Label } from '../label/Label';

type CheckBoxProps = {
  /** @deprecated */
  label?: string;
  /** @deprecated */
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  /** @deprecated */
  wrapperClassName?: string;
  /** @deprecated */
  frame?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const CheckBox = React.forwardRef<HTMLInputElement, CheckBoxProps>(
  (
    {
      label,
      labelProps,
      wrapperClassName,
      frame,
      disabled,
      className,
      ...inputProps
    }: CheckBoxProps,
    ref,
  ) => {
    if (label) {
      console.warn('label is deprecated');
    }
    if (labelProps) {
      console.warn('labelProps is deprecated');
    }
    if (wrapperClassName) {
      console.warn('wrapperClassName is deprecated');
    }
    if (frame) {
      console.warn('frame is deprecated');
    }

    const orionUID = useOrionUID();

    return (
      <div
        className={classNames(
          styles.formWrapper,
          {
            [styles.frame]: frame,
          },
          wrapperClassName,
        )}
      >
        <input
          type="checkbox"
          className={classNames(styles.checkbox, className)}
          disabled={disabled}
          ref={ref}
          id={orionUID}
          {...inputProps}
        />
        {label && (
          <Label htmlFor={inputProps.id || orionUID} {...labelProps}>
            {label}
          </Label>
        )}
      </div>
    );
  },
);

CheckBox.displayName = 'CheckBox';
